<h2>Our Values</h2>
<wackadoo-value-directness></wackadoo-value-directness>
<wackadoo-value-simplicity></wackadoo-value-simplicity>
<wackadoo-value-flexibility></wackadoo-value-flexibility>
<wackadoo-value-substance-over-style></wackadoo-value-substance-over-style>
<wackadoo-value-transparency></wackadoo-value-transparency>
